import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  TextField,
  Grid,
  Button,
} from "@material-ui/core";
import { useState } from "react";
import { fetchPayrollsOfMonths } from "@redux/actions";
import { getPerviousMonth } from "@utils/utils";
import { useDispatch } from "react-redux";
import DropdownSelect from "@components/DropDownSelect";
import {SIGNATURES } from "@utils/constants";
const useStyles = makeStyles((theme) => ({
  formContainer: {
    height: 400,
    overflow: "auto",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  form: {
    marginTop: theme.spacing.unit,
  },
  textField: {
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit * 2,
    marginTop: theme.spacing.unit * 2,
    width: 450,
  },
  submitButton: {
    margin: theme.spacing.unit,
    marginTop: theme.spacing.unit * 2,
  },
  formControl: {
    marginTop: theme.spacing.unit * 2,
    marginLeft: theme.spacing.unit * 2,
    width: 450,
  },
}));

const GenerateMonthBankSlip = ({ employees }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [state, setState] = useState({
    employeeId: "",
    startMonth: "",
    endMonth: "",
    signature: "",
    purpose:"",
    isSubmit: false,
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setState({
      ...state,
      [name]: value,
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const payload = {
      employeeId: state.employeeId,
      startMonth: state.startMonth,
      endMonth: state.endMonth,
      signature: state.signature,
      purpose: state.purpose.charAt(0).toLowerCase() + state.purpose.slice(1)
    };
    dispatch(fetchPayrollsOfMonths(payload));
  };

  return (
   <div className={classes.formContainer}>
     <form className={classes.form} autoComplete="off" onSubmit={handleSubmit}>
      <p className={classes.textField}>Generate Payslip of an Employee</p>
      <FormControl className={classes.formControl}>
        <InputLabel htmlFor="filled-age-native-simple">
          Employee Name
        </InputLabel>
        <Select
          required
          value={state.employeeId}
          onChange={(e) => handleChange(e)}
          inputProps={{
            name: "employeeId",
            id: "filled-age-native-simple",
          }}
        >
          {employees.map(function (employee, i) {
            return (
              <MenuItem value={employee._id} key={i}>
                {employee.first_name} {employee.last_name}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
      <DropdownSelect
        formControl={classes.formControl}
        value={state.signature}
        onChange={(e) => handleChange(e)}
        name={"signature"}
        id={"filled-gender-native-simple"}
        label={"Singnature"}
        options={SIGNATURES}
      />
      <TextField
        name="startMonth"
        label="Choose Starting Month"
        required
        type="month"
        value={state.startMonth}
        onChange={handleChange}
        className={classes.textField}
        InputLabelProps={{
          shrink: true,
        }}
        inputProps={{
          max: getPerviousMonth(),
        }}
      />
      <TextField
        name="endMonth"
        label="Choose Ending Month"
        required
        type="month"
        value={state.endMonth}
        disabled={state.startMonth === ""}
        onChange={handleChange}
        className={classes.textField}
        InputLabelProps={{
          shrink: true,
        }}
        inputProps={{
          min: state.startMonth,
          max: getPerviousMonth(),
        }}
      />
        <TextField
        name="purpose"
        label="Enter the purpose of payslip"
        required
        value={state.purpose}
        onChange={handleChange}
        multiline={true}
        className={classes.textField}
        InputLabelProps={{
          shrink: true,
        }}
      />
      <br />
      <br />
      <Grid container direction="column" justify="center" alignItems="flex-end">
        <Grid item>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            className={classes.submitButton}
            disabled={state.isSubmit}
          >
            Generate Payslip
          </Button>
        </Grid>
      </Grid>
    </form>
   </div>
  );
};

export default GenerateMonthBankSlip;
